<template>
  <flow-part id="UspPart">
    <template #heading>
      <h2 class="intro-medium">
        <template v-if="orderStore.moving_in">Je energiecontract is bijna geregeld!</template>
        <template v-else>
          Bijna een lagere energierekening
        </template>
      </h2>
    </template>
    <template #content>
      <div class="short-start-text">
        Vul onderstaande formulier in om je aanvraag af te ronden.
      </div>
      <ul class="usp-list">
        <li v-if="orderStore.product.gas_included" class="usp">
          <icon icon="check" size="sm" />
          <span class="label"> Je zit nooit zonder gas &amp; stroom </span>
        </li>

        <li v-if="!orderStore.product.gas_included" class="usp">
          <icon icon="check" size="sm" />
          <span class="label"> Je zit nooit zonder stroom </span>
        </li>

        <li v-if="!orderStore.moving_in" class="usp">
          <icon icon="check" size="sm" />
          <span class="label"> Je hoeft je huidige contract niet zelf op te zeggen </span>
        </li>
        <li v-else class="usp">
          <icon icon="check" size="sm" />
          <span class="label">Je betaalt alleen voor wat je echt verbruikt </span>
        </li>
      </ul>

      <div class="offer-explanation" v-if="orderStore.product.offer_explanation">
        <strong>{{ orderStore.product.offer_explanation_header }}</strong><br>
        {{ orderStore.product.offer_explanation }}
      </div>
    </template>
  </flow-part>
</template>

<script setup>
import Icon from '../../../../vue-elements/icon/Icon.vue';
import FlowPart from '../FlowPart.vue';
import { useOrderStore } from '../../stores/orderStore.js';

const orderStore = useOrderStore();
</script>


<style lang="scss" scoped>
@use 'assets/scss/all' as *;

#UspPart {
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  padding-top: 12px;

  @include breakpoint-up(md) {
    padding-top: 0;
    font-size: 17px;
  }
}

.intro-medium {
  @include header-6;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 8px;

  @include breakpoint-up(md) {
    margin-bottom: 16px;
    font-size: 24px;
  }
}

.short-start-text {
  margin-bottom: 16px;
}

.usp-list {
  @include flex-col-start;

  padding: 0;
  list-style: none;
  margin: 0;


  .usp {
    @include flex-row-start();

    align-items: flex-start;
    margin: 4px 0;
  }

  .icon-element {
    margin-top: 4px;
    min-width: 16px;
    background-color: $text-positive;
    margin-right: 4px;

    @include breakpoint-up(md) {
      margin-top: 6px;
    }
  }
}

.offer-explanation {
  @include content-short;
  margin-top: 16px;

  @include breakpoint-up(md) {
    @include intro-medium;
  }
}
</style>
